import React from 'react';

import styled from '@emotion/styled';

export interface UDCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const CardWrapper = styled.div<{ $clickable: boolean }>`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;
    transition: border-color 0.15s ease;
    &:hover {
      border-color: #bdbdbd;
    }
  `}
`;

const UDCard: React.FC<UDCardProps> = ({ children, className, style, onClick }) => {
  return (
    <CardWrapper $clickable={!!onClick} className={className} style={style} onClick={onClick}>
      {children}
    </CardWrapper>
  );
};

export default UDCard;
